// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3E8D1","dragIcon":"Choice_dragIcon__VbXN6","left":"Choice_left__3VE7_","input":"Choice_input__ZzIlK"};